module.exports = __webpack_public_path__ + "img/userB25.83659dc9.jpg";